import { useNavigate } from "react-router-dom";
import { Compass, ArrowLeft } from "lucide-react";
import { motion } from "framer-motion";
import { EASE, usePageMeta } from "../lib/motion";
import { t } from "../i18n";

const NotFound = () => {
  usePageMeta("Page Not Found", "The page you are looking for could not be found.");
  const navigate = useNavigate();
  return (
    <main className="min-h-screen bg-navy-deep flex items-center justify-center relative overflow-hidden grain" data-testid="not-found-page">
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none">
        <span className="font-display font-black text-[38vw] leading-none text-white/[0.02]">404</span>
      </div>
      <div className="relative text-center px-6">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: EASE }}
        >
          <span className="inline-flex h-16 w-16 items-center justify-center rounded-full border border-gold/40 bg-gold/10 mb-8">
            <Compass className="h-8 w-8 text-gold" />
          </span>
          <p className="text-xs font-semibold tracking-[0.35em] text-gold font-display mb-4">{t("notFound.eyebrow")}</p>
          <h1 className="font-display font-extrabold tracking-tight text-white text-4xl sm:text-5xl mb-5">
            {t("notFound.title")}
          </h1>
          <p className="text-slate-400 max-w-md mx-auto leading-relaxed mb-10">
            {t("notFound.text")}
          </p>
          <button
            onClick={() => navigate("/")}
            data-testid="not-found-home-btn"
            className="btn-gold rounded-full px-8 py-4 text-sm font-bold tracking-wider font-display inline-flex items-center gap-2"
          >
            <ArrowLeft className="h-4 w-4" /> {t("notFound.button")}
          </button>
        </motion.div>
      </div>
    </main>
  );
};

export default NotFound;
